import { styled } from "@mui/material/styles";

export const ItemContainer = styled("div", {
  label: "item-container",
})`
  font-size: 16px;
  font-weight: 400;
`;

export const ItemTitle = styled("h3", {
  label: "item-title",
})`
  color: ${({ theme }) => theme.palette.color.text.primary};
`;

export const ItemLongDescription = styled("h3", {
  label: "long-description",
})`
  color: ${({ theme }) => theme.palette.color.gray[50]};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  margin-right: ${({ theme }) => theme.spacing(4.5)};
`;

export const ItemDesc = styled("div", {
  label: "item-desc",
})`
  color: ${({ theme }) => theme.palette.color.primary.main};

  & + & {
    margin-top: ${({ theme }) => theme.spacing(3)};
  }
`;
